var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEbMenuLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.234,
    height: 47.152,
    viewBox: "0 0 80.234 47.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(3125.284 -10508.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M104.268,37.822a12.91,12.91,0,0,0-4.934-4.894,13.544,13.544,0,0,0-6.679-1.7,10.869,10.869,0,0,0-9.448,5.126V19.23a6.532,6.532,0,0,0-6.558-6.5V59.278h6.558V54.734a10.83,10.83,0,0,0,9.448,5.142,13.558,13.558,0,0,0,6.679-1.7,12.842,12.842,0,0,0,4.934-4.925,15.121,15.121,0,0,0,1.866-7.7,15.087,15.087,0,0,0-1.866-7.729M98.252,50.266a7.644,7.644,0,0,1-3.04,2.984,8.709,8.709,0,0,1-4.182,1.015,7.4,7.4,0,0,1-3.671-1.015A8.113,8.113,0,0,1,84.381,50.3a9.01,9.01,0,0,1-1.174-4.744,9.022,9.022,0,0,1,1.174-4.746,8.143,8.143,0,0,1,2.979-2.954,7.417,7.417,0,0,1,3.671-1.015,8.723,8.723,0,0,1,4.182,1.015,7.661,7.661,0,0,1,3.04,2.984A9.255,9.255,0,0,1,99.4,45.551a9.25,9.25,0,0,1-1.144,4.715",
    transform: "translate(-3168.269 10495.284)",
    fill: "#f8fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M40.381,33.568a11.424,11.424,0,0,0-4.724-4.8A15.416,15.416,0,0,0,28.2,27.092a15.817,15.817,0,0,0-7.642,1.762,12.314,12.314,0,0,0-5.023,4.983,15.466,15.466,0,0,0-1.776,7.58A15.544,15.544,0,0,0,15.5,48.937a12.361,12.361,0,0,0,4.964,5.013,15.046,15.046,0,0,0,7.431,1.79,17.144,17.144,0,0,0,8.245-1.851,14.351,14.351,0,0,0,5.6-5.55l-.571-.232a8.42,8.42,0,0,0-7.78.917c-.18.117-.365.228-.554.33A9.594,9.594,0,0,1,28.2,50.429a8.168,8.168,0,0,1-4.3-1.074,6.683,6.683,0,0,1-2.677-3.133,11.064,11.064,0,0,1-.808-3.312H41.915a4.929,4.929,0,0,0,.091-.777c.019-.358.03-.7.03-1.015a15.987,15.987,0,0,0-1.655-7.549m-16.457-.507a7.879,7.879,0,0,1,4.212-1.074,6.968,6.968,0,0,1,3.58.9,6.32,6.32,0,0,1,2.407,2.506,7.557,7.557,0,0,1,.836,3.1H20.575a10.473,10.473,0,0,1,.7-2.327,6.746,6.746,0,0,1,2.647-3.1",
    transform: "translate(-3139.037 10499.42)",
    fill: "#f8fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M151.5,50.3h0a6.412,6.412,0,0,1,6.439-6.386h6.95a6.412,6.412,0,0,1-6.439,6.386Z",
    transform: "translate(-3209.935 10504.262)",
    fill: "#f8fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M151.5,43.552h0a6.412,6.412,0,0,1,6.439-6.386h6.95a6.412,6.412,0,0,1-6.439,6.386Z",
    transform: "translate(-3209.935 10502.319)",
    fill: "#f8fbfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M151.5,36.579h0a6.412,6.412,0,0,1,6.439-6.386h6.95a6.412,6.412,0,0,1-6.439,6.386Z",
    transform: "translate(-3209.935 10500.313)",
    fill: "#f8fbfd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbMenuLogo);
export default __webpack_public_path__ + "static/media/eb_menu_logo.9270a6ef2d51523b4a92fb72c0c81c60.svg";
export { ForwardRef as ReactComponent };